module.exports = __webpack_public_path__ + "img/6.def9c577.jpg";